import React from 'react'

const Footer = () => {
  return (
    <div className='bg-black text-center p-6 text-white ' >
    Copyright © 2025 All Rights Reserved
    </div>
  )
}

export default Footer
